function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.35,29.55a.74.74,0,0,1-.6.3H3.25a.75.75,0,0,1-.72-1l2.2-7.5,1.44.42L4.25,28.35H27.74l-2-6.53,1.44-.44,2.3,7.5A.76.76,0,0,1,29.35,29.55Zm-17.9-17A4.55,4.55,0,1,1,16,17.15,4.55,4.55,0,0,1,11.45,12.6Zm1.5,0a3.05,3.05,0,1,0,3.05-3A3.06,3.06,0,0,0,13,12.6ZM6.42,17a11.06,11.06,0,0,1-.87-4.31,10.28,10.28,0,0,1,10-10.55h.39A10.58,10.58,0,0,1,26.45,12.7,11.28,11.28,0,0,1,25.6,17a10.58,10.58,0,0,1-2,2.92L16.53,27a.73.73,0,0,1-.53.22.74.74,0,0,1-.53-.22l-7.1-7.1A10.51,10.51,0,0,1,6.42,17Zm.63-4.33a9.66,9.66,0,0,0,.74,3.73,9.29,9.29,0,0,0,1.66,2.48L16,25.44l6.57-6.57a8.88,8.88,0,0,0,1.65-2.48A9.64,9.64,0,0,0,25,12.7a9.09,9.09,0,0,0-9-9h-.33a8.78,8.78,0,0,0-8.52,9Z",
  fill: "#33ba69"
});

var SvgMapIcon = function SvgMapIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_icon.bf8b31fb.svg";
export { ForwardRef as ReactComponent };